module.exports = __webpack_public_path__ + "static/media/feature-mini-card1.527ee187.webp";